/**
 * Component - contactInfo
 */

export const contactInfo = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-contactInfo') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
    const singleList: HTMLElement[] = Array.from(component.querySelectorAll('.js-contactInfo-singleWrapper'))

    const phoneTriggerList: HTMLElement[] = Array.from(component.querySelectorAll('.js-contactInfo-singleTitle'))
    const triggerList: HTMLElement[] = Array.from(component.querySelectorAll('.js-contactInfo-mapButtonBackground'))
    const buttonList: HTMLElement[] = Array.from(component.querySelectorAll('.js-contactInfo-mapButton'))

    triggerList.forEach((trigger:HTMLElement) => {
      trigger.addEventListener('click', () => {
        if (window.innerWidth >= 993) {
          const triggerID = parseInt(trigger.dataset.key as string)
          const activeButton = component.querySelector(`.js-contactInfo-mapButton[data-key="${triggerID}"]`)
          const activeSingle = component.querySelector(`.js-contactInfo-singleWrapper[data-key="${triggerID}"]`)

          triggerList.forEach((elem) => {
            elem.classList.remove('-active')
          })
          buttonList.forEach((elem) => {
            elem.classList.remove('-active')
          })
          singleList.forEach((elem) => {
            elem.classList.remove('-active')
          })

          trigger.classList.add('-active')
          if (activeButton) {
            activeButton.classList.add('-active')
          }
          if (activeSingle) {
            activeSingle.classList.add('-active')
          }
        }
      })
    })

    phoneTriggerList.forEach((phoneTrigger:HTMLElement) => {
      phoneTrigger.addEventListener('click', () => {
        if (window.innerWidth <= 992) {
          let manualRemove = false
          const manualTrigger = phoneTrigger.closest('.js-contactInfo-singleWrapper') as unknown as HTMLElement
          const triggerID = parseInt(manualTrigger.dataset.key as string)
          const activeButton = component.querySelector(`.js-contactInfo-mapButton[data-key="${triggerID}"]`)
          const activeSingle = component.querySelector(`.js-contactInfo-singleWrapper[data-key="${triggerID}"]`)

          if (manualTrigger.classList.contains('-active')) {
            manualRemove = true
          }

          triggerList.forEach((elem) => {
            elem.classList.remove('-active')
          })
          buttonList.forEach((elem) => {
            elem.classList.remove('-active')
          })
          singleList.forEach((elem) => {
            elem.classList.remove('-active')
          })

          if (!manualRemove) {
            phoneTrigger.classList.add('-active')
            if (activeButton) {
              activeButton.classList.add('-active')
            }
            if (activeSingle) {
              activeSingle.classList.add('-active')
            }
          }
        }
      })
    })
  })
}
